import {RetreivedPlan} from 'Quoting/models/DTOs/QuoteForm';
import {Map as ImmutableMap} from 'immutable';
import {createNewGIM2PlanObjectWithDefaults} from './GIM2';
import {createNewGHI3PlanObjectWithDefaults} from './GHI3';

export const getHospitalIndemnityPlanObject = (
  plan: RetreivedPlan | undefined,
  quoteRootId: string | undefined,
  quoteParentId: string | undefined,
  coverageEffDate: string,
  defaultValues: ImmutableMap<string, any> | undefined
) => {
  switch (plan?.planCode) {
    case 'GIM2':
      return createNewGIM2PlanObjectWithDefaults(
        plan,
        quoteRootId ?? '',
        quoteParentId ?? '',
        coverageEffDate,
        defaultValues ?? ImmutableMap()
      );
    case 'GHI3':
      return createNewGHI3PlanObjectWithDefaults(
        plan,
        quoteRootId ?? '',
        quoteParentId ?? '',
        coverageEffDate,
        defaultValues ?? ImmutableMap()
      );
  }
};
